<template>
  <!-- Main Content  -->
  <div class="container">
    <section class="content-header">
      <h1>{{ $t("登録情報の変更") }}</h1>
    </section>

    <modallogin v-show="isModalVisible" @close="closeModal"></modallogin>

    <div class="loader" v-if="this.dataloading">
      <div class="loader-inner ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <section v-else class="content-wrap">
      <div class="setting">
        <!-- common error messages -->
        <div class="warning" id="warning" v-if="commonErrors.length">
          <ul>
            <li v-for="(error, index) in commonErrors" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>

        <div class="col-setting-left">
          <!-- edit newsletter flag -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t("メールマガジンの購読") }}</h2>
            <div class="col-center">
              <form @submit.prevent="updateNewsletter">
                <div class="radio_group">
                  <input
                    type="radio"
                    name="newsletter"
                    id="newsletter_on"
                    value="1"
                    v-model="news_letter"
                    @click="newsletterChangeEmitator"
                  />
                  <label for="newsletter_on">{{ $t("購読する") }}</label>
                </div>

                <div class="radio_group">
                  <input
                    type="radio"
                    name="newsletter"
                    id="newsletter_off"
                    value="0"
                    v-model="news_letter"
                    @click="newsletterChangeEmitator"
                  />
                  <label for="newsletter_off">{{ $t("購読しない") }}</label>
                </div>
                <button
                  id="send-event"
                  v-bind:style="[
                    !newsletterChangeEmit
                      ? {
                          'pointer-events': 'none',
                          'background-color': '#c9cbcc'
                        }
                      : {}
                  ]"
                  type="submit"
                >
                  {{ $t("変更する") }}
                </button>
              </form>
            </div>
          </div>
          <!-- End of newsletter flag -->

          <!-- edit profile -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t("任意の項目") }}</h2>
            <div>
              <form @submit.prevent="editProfile">
                <p>{{ $t("ご希望の表示言語") }}</p>
                <div>
                  <label class="settingSelect">
                    <select v-model="language_id">
                      <option
                        v-for="(language, key) in languages"
                        v-bind:value="key"
                        v-bind:key="key"
                        >{{ language }}</option
                      >
                    </select>
                  </label>
                </div>

                <p>{{ $t("名") }}</p>
                <div>
                  <input
                    type="text"
                    v-model="user_first_name"
                    :placeholder="$t('名')"
                  />
                </div>

                <p>{{ $t("姓") }}</p>
                <div>
                  <input
                    type="text"
                    v-model="user_family_name"
                    :placeholder="$t('姓')"
                  />
                </div>

                <p>{{ $t("誕生日") }}</p>

                <span
                  v-if="commonErrors.hasOwnProperty('birthday')"
                  style="color:red;"
                  >{{ commonErrors.birthday }}</span
                >

                <div class="birthSelect">
                  <label class="settingSelect">
                    <select
                      name="birthday_d"
                      v-model="birthday_d"
                      v-on:change="instantValidator($event, 'birthday')"
                    >
                      <option
                        v-for="day in days"
                        v-bind:value="day"
                        v-bind:key="day"
                        >{{ day }}</option
                      >
                    </select>
                  </label>

                  <label class="settingSelect">
                    <select
                      name="birthday_m"
                      v-model="birthday_m"
                      v-on:change="instantValidator($event, 'birthday')"
                    >
                      <option
                        v-for="month in months"
                        v-bind:value="month"
                        v-bind:key="month"
                        >{{ month }}</option
                      >
                    </select>
                  </label>

                  <label class="settingSelect">
                    <select
                      name="birthday_y"
                      v-model="birthday_y"
                      v-on:change="instantValidator($event, 'birthday')"
                    >
                      <option
                        v-for="year in years"
                        v-bind:value="year"
                        v-bind:key="year"
                        >{{ year }}</option
                      >
                    </select>
                  </label>
                </div>

                <div>
                  <p>{{ $t("性別") }}</p>
                  <div class="radio_group">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      v-model="gender"
                    />
                    <label for="male">{{ $t("男") }}</label>
                  </div>

                  <div class="radio_group">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      v-model="gender"
                    />
                    <label for="female">{{ $t("女") }}</label>
                  </div>

                  <div class="radio_group">
                    <input
                      type="radio"
                      name="gender"
                      value="other"
                      id="other"
                      v-model="gender"
                    />
                    <label for="other">{{ $t("その他") }}</label>
                  </div>
                </div>

                <p>{{ $t("国籍") }}</p>
                <div>
                  <!-- <label class="settingSelect">
                                        <select name="country_code" v-model="country_code">
                                            <option value selected disabled>{{ $t('国籍') }}</option>
                                            <option
                                                v-for="nationality in nationalities"
                                                v-bind:value="nationality.country_code"
                                                v-bind:key="nationality.country_code"
                                            >{{ nationality.nationality_name }}</option>
                                        </select>
                                    </label> -->
                  <v-select
                    class="style-chooser"
                    v-model="country_code"
                    :value="country_code"
                    :options="nationalities"
                    :reduce="nationality_name => nationality_name.country_code"
                    label="nationality_name"
                  />
                </div>

                <p>
                  {{
                    $t(
                      "これらの情報は本サービスを改善するための解析用です。他ユーザーに共有されることはありません。"
                    )
                  }}
                </p>

                <button type="submit">{{ $t("変更する") }}</button>
              </form>
            </div>
          </div>
          <!-- End of Edit Profile -->
        </div>
        <!-- ./col-setting-left -->

        <div class="col-setting-right">
          <!-- Customize Interest -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t("Customize Interest") }}</h2>
            <div class="col-center">
              <div class="user-select-categories">
                <a
                  v-for="(category, index) in user_interested_category"
                  :key="index"
                  :href="
                    MATCHA_MAIN_SITE +
                      '/' +
                      languageName +
                      '/list/?region=all&category=' +
                      category.category_id
                  "
                  >{{ category.category_name }}</a
                >
              </div>
              <div class="customize-interest-button">
                <router-link to="customize-interest" class="btn btn-green">{{
                  $t("変更する")
                }}</router-link>
              </div>
            </div>
          </div>
          <!-- End of Customize Interest -->

          <!-- Connected Providers -->
          <div
            class="col-setting"
            v-if="userAttributes.providerData.length > 0"
          >
            <h2 class="profTitle">{{ $t("Connecting accounts") }}</h2>
            <div class="col-center">
              <div
                class="avatar_card"
                v-for="(provider, index) in userAttributes.providerData"
                :key="index"
              >
                <img
                  :src="provider.photoURL"
                  :alt="provider.displayName"
                  class="avatar_img"
                />
                <h2 class="avatar_name">{{ provider.displayName }}</h2>
                <span class="avatar_email">{{ provider.email }}</span>
                <div
                  v-bind:class="
                    'avatar_provider ' + provider.providerId.replace('.com', '')
                  "
                >
                  <i
                    v-bind:class="
                      provider.providerId.replace('.com', '') == 'google'
                        ? 'icon-googleplus'
                        : provider.providerId.replace('.com', '') == 'password'
                        ? 'icon-envelope'
                        : 'icon-' + provider.providerId.replace('.com', '')
                    "
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Connected Providers -->

          <!-- edit email address -->
          <div class="col-setting">
            <h2 v-if="!this.$store.getters.email">
              {{ $t("メールアドレスの登録") }}
            </h2>
            <h2 class="profTitle" v-else>{{ $t("メールアドレスの変更") }}</h2>

            <form class="mail-confing" @submit.prevent="modifyEmail">
              <div>
                <h3 class="profSubTitle" v-if="this.$store.getters.email">
                  {{ $t("現在のメールアドレス") }}
                </h3>
                <p v-if="this.$store.getters.email">
                  {{ this.$store.getters.email }}
                </p>
              </div>

              <h3 class="profSubTitle">{{ $t("新しいメールアドレス") }}：</h3>
              <input
                name="email"
                type="text"
                v-on:blur="instantValidator($event, 'email')"
                v-on:change="instantValidator($event, 'email')"
                v-model="email"
                :placeholder="$t('新しいメールアドレス')"
              />
              <span
                v-if="commonErrors.hasOwnProperty('email')"
                style="color:red;"
                >{{ commonErrors.email }}</span
              >

              <button
                v-bind:style="[
                  commonErrors.hasOwnProperty('email')
                    ? {
                        'pointer-events': 'none',
                        'background-color': '#c9cbcc'
                      }
                    : {}
                ]"
                type="submit"
              >
                {{ $t("変更する") }}
              </button>
            </form>
          </div>
          <!-- End of Email Settings-->

          <!-- Set New Password -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t("Password reset") }}</h2>

            <form class="password-reset" @submit.prevent="resetNewPassword">
              <input
                v-model="password"
                :type="password_type"
                v-on:blur="instantValidator($event, 'password')"
                v-on:change="instantValidator($event, 'password')"
                :placeholder="this.$t('パスワード')"
                id="u_auth_pass"
                autocomplete="new-password"
              />
              <span class="show-hide-password" v-on:click="showHidePassword"
                ><i :class="pass_type_icon"></i
              ></span>
              <p class="caution" id="password-c">{{ passError }}</p>

              <input
                v-model="rePassword"
                :type="password_type"
                v-on:blur="instantValidator($event, 're-password')"
                v-on:change="instantValidator($event, 're-password')"
                :placeholder="this.$t('パスワードを再記入')"
                id="u_auth_rePass"
                autocomplete="new-password"
              />
              <span class="show-hide-password" v-on:click="showHidePassword"
                ><i :class="pass_type_icon"></i
              ></span>
              <p class="caution" id="password-c">{{ rePassError }}</p>

              <button
                v-bind:style="[
                  passError || rePassError
                    ? {
                        'pointer-events': 'none',
                        'background-color': '#c9cbcc'
                      }
                    : {}
                ]"
                type="submit"
              >
                {{ $t("変更する") }}
              </button>
            </form>
          </div>
          <!-- End of Email Settings-->

          <!-- delete account -->
          <div class="col-setting">
            <p class="settingDelete">
              <router-link to="deleteaccount" class="arrowRight">{{
                $t("アカウントの削除")
              }}</router-link>
            </p>
          </div>
          <!-- End of delete account -->
        </div>
        <!-- ./col-setting-right -->
      </div>
    </section>
  </div>
  <!-- Main Content -->
</template>

<script>
import User from "@/api/user";
import * as constants from "@/constants";
import UserUtils from "@/utils/UserUtils";
import { mapState, mapGetters } from "vuex";
import modallogin from "@/components/ReAuthenticate";
import { getCategoryLists, getInterestList } from "@/api/user-interest";
import {
  changeCurrentEmailAddress,
  signOutUser,
  changeFirebaseLanguage,
  updateUserPassword
} from "@/auth/user-meta";
import "vue-select/dist/vue-select.css";

const loader = document.getElementById("loading");

export default {
  components: {
    modallogin
  },
  mounted() {
    // Refresh ID Token
    this.$store.dispatch("fetchSetNewToken");
    this.$gtm.trackView("ProfileSettings", "currentpath");

    // get and set profiles
    this.profiles = this.$store.state.user.userMeta;
    this.news_letter =
      this.profiles.newsletter === null ? 0 : this.profiles.newsletter;
    if (this.profiles.birthday) {
      let bDay = UserUtils.getDate(this.profiles.birthday);
      // console.log(bDay)
      this.birthday_y = parseInt(bDay.year);
      this.birthday_m = parseInt(bDay.month);
      this.birthday_d = parseInt(bDay.day);
    }
    this.country_code = this.userMeta.country_code;
    this.language_id = this.userMeta.language_id;
    this.user_first_name = this.userMeta.user_first_name;
    this.user_family_name = this.userMeta.user_family_name;
    this.gender = this.userMeta.gender;

    if (this.matcaCategoryList.length <= 0) {
      // Get All Category List And Assign to Computed Data
      getCategoryLists({ lang_id: this.lang_id })
        .then(response => {
          this.all_categories = response.data;

          // Get User Interest List And Assign to Computer Data
          getInterestList(this.token)
            .then(res => {
              this.user_selected_categories = res;
              this.user_interested_category = response.data.filter(cat => {
                if (res.indexOf(cat.category_id) >= 0) {
                  return cat;
                }
              });
              this.dataloading = false;
            })
            .catch(error => {
              // console.log(error)
              this.dataloading = false;
            });
        })
        .catch(err => {
          // console.log(err)
          this.dataloading = false;
        });
    } else {
      this.all_categories = this.matcaCategoryList;

      getInterestList(this.token)
        .then(res => {
          this.user_selected_categories = res;
          this.user_interested_category = this.all_categories.filter(cat => {
            if (res.indexOf(cat.category_id) >= 0) {
              return cat;
            }
          });
          this.dataloading = false;
        })
        .catch(error => {
          // console.log(error)
          this.dataloading = false;
        });
    }
  },

  data: () => ({
    MATCHA_MAIN_SITE: process.env.MATCHA_MAIN_SITE,
    dataloading: true,
    all_categories: [],
    user_interested_category: [],
    user_selected_categories: [],

    years: [...Array(100).keys()]
      .map(i => new Date().getFullYear() - i)
      .reverse(),
    months: [...Array(12).keys()].map(i => i + 1),
    days: [...Array(31).keys()].map(i => i + 1),
    email: "",
    languages: UserUtils.getLanguages(),
    language_id: 1,
    user_first_name: "",
    user_family_name: "",
    gender: "",
    profiles: [],
    news_letter: 0,
    nationalities: null,
    country_code: null,
    birthday_y: "",
    birthday_m: "",
    birthday_d: "",
    country: null,
    newsletterChangeEmit: "",
    commonErrors: [],
    isModalVisible: false,
    passError: "",
    rePassError: "",
    password: "",
    rePassword: "",
    pass_type_icon: "icon-eye-slash",
    password_type: "password",
    executeAfterReLogin: ""
  }),

  computed: {
    ...mapState(["clips", "user"]),
    ...mapGetters({
      token: "token",
      lang_id: "languageId",
      languageName: "languageName",
      userId: "userId",
      userAttributes: "userAttributes",
      matcaCategoryList: "matcaCategoryList",
      userInterestList: "userInterestList",
      userInterestedCategory: "userInterestedCategory",
      userMeta: "userMeta",
      reAuthenticationRequire: "reAuthenticationRequire"
    })
  },

  created() {
    // ISO 3166-1準拠の国名を取得
    User.getNationality().then(
      response => (this.nationalities = response.data)
    );
    // console.log(this.nationalities)
  },

  methods: {
    reAuthenticationOperation() {
      if (this.executeAfterReLogin) {
        loader.style.display = "block";
        this.$store
          .dispatch("updateUser")
          .then(res => {
            if (this.executeAfterReLogin === "modifyEmail") {
              this.modifyEmail();
              this.executeAfterReLogin = "";
            } else if (this.executeAfterReLogin === "resetNewPassword") {
              this.resetNewPassword();
              this.executeAfterReLogin = "";
            } else {
              window.location.href = "/";
            }
          })
          .catch(err => {
            loader.style.display = "none";
            window.location.href = "/";
          });
      } else {
        window.location.href = "/";
      }
    },
    showHidePassword() {
      if (this.password_type === "password") {
        this.password_type = "text";
        this.pass_type_icon = "icon-eye";
      } else {
        this.password_type = "password";
        this.pass_type_icon = "icon-eye-slash";
      }
    },
    /**
     * regist and modify email
     */
    modifyEmail() {
      this.commonErrors = [];
      if (this.email === null) {
        this.commonErrors.email = this.$t("Email field is empty.");
        return;
      } else if (!this.emailValidator(this.email)) {
        this.commonErrors.email = this.$t("Invalid email adrress.");
        return;
      }

      if (this.reAuthenticationRequire) {
        this.showModal();
        this.executeAfterReLogin = "modifyEmail";
        return;
      }

      loader.style.display = "block";
      let bodyParams = {
        user_id: this.userId,
        email: this.$sanitize(this.email)
      };

      changeCurrentEmailAddress(this.$sanitize(this.email))
        .then(res => {
          User.updateUserMeta(bodyParams, this.token)
            .then(response => {
              if (response.status === 200) {
                this.$store
                  .dispatch("updateUser")
                  .then(result => {
                    loader.style.display = "none";
                    this.$store.dispatch("setReAuthenticationFlag", true);
                    this.email = "";
                    this.$swal({
                      text: this.$t(
                        "Your email address has been changed successfully!"
                      ),
                      type: "success"
                    });
                  })
                  .catch(e => {
                    loader.style.display = "none";
                    this.sweetError(
                      e
                        ? this.$t(e)
                        : this.$t(
                            "Something going to be wrong! Please try later."
                          )
                    );
                  });
              }
            })
            .catch(error => {
              loader.style.display = "none";
              this.sweetError(
                error.response.message
                  ? this.$t(error.response.message)
                  : this.$t("Something going to be wrong! Please try later.")
              );
            });
        })
        .catch(err => {
          // console.log(err)
          if (err.code == "auth/requires-recent-login") {
            this.$swal({
              text: this.$t(err.message),
              type: "error"
            }).then(() => {
              loader.style.display = "none";
              this.showModal();
            });
          } else {
            loader.style.display = "none";
            this.sweetError(this.$t(err.message));
          }
        });
    },

    /**
     * Reset new Password
     */
    resetNewPassword() {
      if (!this.password) {
        this.passError = this.$t("Please input a valid password.");
        return;
      } else if (!this.rePassword || this.password !== this.rePassword) {
        this.rePassError = this.$t("Password does not matched!");
        return;
      }

      if (this.reAuthenticationRequire) {
        this.showModal();
        this.executeAfterReLogin = "resetNewPassword";
        return;
      } else {
        loader.style.display = "block";
        let bodyParams = {
          user_id: this.userId,
          password: this.$sanitize(this.password)
        };

        updateUserPassword(this.$sanitize(this.password))
          .then(result => {
            // console.log(result)
            User.saveNewPassword(bodyParams)
              .then(res => {
                // console.log(res)
                loader.style.display = "none";
                this.$store.dispatch("setReAuthenticationFlag", true);
                this.password = "";
                this.rePassword = "";
                this.$swal({
                  text: this.$t("Password reset successfully!"),
                  type: "success"
                });
              })
              .catch(err => {
                // console.log(err)
                loader.style.display = "none";
                this.sweetError(
                  err.response.message
                    ? this.$t(err.response.message)
                    : this.$t("Something going to be wrong! Please try later.")
                );
              });
          })
          .catch(error => {
            // console.log(error)
            loader.style.display = "none";
            this.sweetError(
              erro.message
                ? error.message
                : this.$t("Something going to be wrong! Please try later.")
            );
          });
      }
    },

    /**
     * Notify Newsletter Change Emitter
     */
    newsletterChangeEmitator(e) {
      this.newsletterChangeEmit = "changed";
    },

    /**
     * update newsletter flag
     */
    updateNewsletter() {
      this.commonErrors = [];
      if (!this.newsletterChangeEmit) return;
      loader.style.display = "block";

      let bodyParams = { newsletter: parseInt(this.news_letter) };

      User.updateUserMeta(bodyParams, this.token)
        .then(response => {
          // console.log(response)
          if (response.status !== 200) {
            throw new Exception();
          }
          // Update Vue Store
          this.$store.dispatch("setUserMeta", response.data[0]);

          loader.style.display = "none";
          this.$swal({
            text: this.$t(
              "登録内容が変更されました。引き続き、WEBマガジンMATCHAをお楽しみ下さい。"
            ),
            type: "success"
          });
        })
        .catch(error => {
          loader.style.display = "none";
          this.sweetError(
            this.$t("Something going to be wrong! Please try later.")
          );
        });
    },

    /**
     * edit profile
     */
    editProfile() {
      this.commonErrors = [];

      let bodyParams = {
        user_id: this.userId,
        language_id: this.language_id,
        country_code: this.country_code,
        user_first_name: this.user_first_name
          ? this.$sanitize(this.user_first_name)
          : "",
        user_family_name: this.user_family_name
          ? this.$sanitize(this.user_family_name)
          : "",
        birthday: `${this.birthday_y}-${String(this.birthday_m).padStart(
          2,
          0
        )}-${String(this.birthday_d).padStart(2, 0)}`,
        gender: this.gender
      };

      if (!this.birthday_y || !this.birthday_m || !this.birthday_d) {
        delete bodyParams.birthday;
      }
      // console.log(bodyParams);

      try {
        loader.style.display = "block";

        User.updateUserMeta(bodyParams, this.token)
          .then(response => {
            if (response.status !== 200) throw new Exception();

            this.$store
              .dispatch("updateUser")
              .then(result => {
                loader.style.display = "none";
                this.$swal({
                  text: this.$t(
                    "Your information has been updated successfully!"
                  ),
                  type: "success"
                }).then(() => {
                  let newLangName = UserUtils.convertToLanguageName(
                    bodyParams.language_id
                  );
                  this.languageSwitching(newLangName);
                });
              })
              .catch(e => {
                loader.style.display = "none";
                this.sweetError(
                  e
                    ? this.$t(e)
                    : this.$t("Something going to be wrong! Please try later.")
                );
              });
          })
          .catch(error => {
            loader.style.display = "none";
            if (error.response.messag) {
              this.sweetError(this.$t(error.response.message));
            } else {
              this.sweetError(
                this.$t("Something going to be wrong! Please try later.")
              );
            }
          });
      } catch (error) {
        loader.style.display = "none";
        this.sweetError(
          this.$t("Something going to be wrong! Please try later.")
        );
      }
    },

    languageSwitching: function(languageName) {
      changeFirebaseLanguage(languageName);
      this.$i18n.locale = languageName;
      document.body.className = languageName;
    },

    /**
     * Data & Input Validation Section
     */
    instantValidator(el, type) {
      // console.log(this.commonErrors.email)
      if (!type) return;

      switch (type) {
        case "email":
          if (!this.email) {
            this.commonErrors.email = this.$t("Invalid email adrress.");
          } else if (!this.emailValidator(this.email)) {
            this.commonErrors.email = this.$t("Invalid email adrress.");
          } else if (this.email === this.$store.state.user.email) {
            this.commonErrors.email = this.$t(
              "The email address has already been taken."
            );
          } else {
            this.commonErrors = [];
            return;
          }
          break;

        case "password":
          if (!this.password) {
            this.passError = this.$t("Password field is empty.");
          } else if (!this.passwordValidator(this.password)) {
            if (this.password.length < 6) {
              this.passError = this.$t(
                "Please set a password with more than 6 characters."
              );
            } else if (this.password.length > 16) {
              this.passError = this.$t(
                "Please set a password with less than 16 characters."
              );
            } else if (
              !/^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9])+$/.test(this.password)
            ) {
              this.passError = this.$t(
                "Password should contain both alphabets and numbers."
              );
            } else {
              this.passError = this.$t("Invalid password format.");
            }
          } else {
            this.passError = "";
            return;
          }
          break;

        case "re-password":
          if (!this.rePassword || this.password !== this.rePassword) {
            this.rePassError = this.$t("Password does not matched!");
          } else {
            this.rePassError = "";
            return;
          }
          break;

        case "birthday":
          if (!this.birthday_y || !this.birthday_m || !this.birthday_d) {
            this.commonErrors.birthday = this.$t(
              "Invalid Format! Must select each of Month, Date & Year."
            );
          } else {
            this.commonErrors = [];
            return;
          }
          break;

        default:
          this.commonErrors = [];
          return;
          break;
      }
    },

    emailValidator: function(email) {
      if (!email) return false;
      if (email === this.$store.state.user.email) return false;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    passwordValidator: function(pass) {
      if (!pass) return false;
      var re = /^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9]).{5,16}$/; //previous one : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(pass);
    },

    sweetError(text) {
      this.$swal({
        text: text,
        type: "error"
      });
    },

    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    }
  },

  //For Header & Meta Tag
  metaInfo() {
    return {
      title:
        this.$t("登録情報の変更") + " | MATCHA - JAPAN TRAVEL WEB MAGAZINE",
      htmlAttrs: {
        lang: this.$store.state.languageName
      }
    };
  }
};
</script>

<style>
.style-chooser .vs__dropdown-menu,
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle {
  border-radius: unset;
  padding: 10px 0px;
}
.style-chooser .vs__selected-options {
  margin-bottom: 0px;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/index.vue